import React from "react";
import dayjs from "dayjs";
import localizedFormat from "dayjs/plugin/localizedFormat";
import "dayjs/locale/es";

import { Tag } from "../../atoms/tags/tag-front";

interface CardBlogProps {
	variant?: string;
	creationDate: string | Date;
	desc: string;
	image?: string;
	icon?: string;
	tags: Array<{
		text: string;
		href?: string;
		openLinkInNewTab?: boolean;
	}>;
	title: string;
	index?: number;
	link: string;
}

export const CardBlog = ({
	variant,
	creationDate,
	desc,
	image,
	icon,
	tags,
	title,
	index,
	link,
}: CardBlogProps) => {
	dayjs.locale("es");
	dayjs.extend(localizedFormat);
	let bgClass = "card-blog-dark-blue";
	let tagClass = "dark-blue";
	if (index) {
		switch (index.toString()) {
			case "0":
				bgClass = "card-blog-dark-blue";
				tagClass = "dark-blue";
				break;
			case "4":
				bgClass = "card-blog-green";
				tagClass = "green";
				break;
			case "1":
				bgClass = "card-blog-green-blue";
				tagClass = "green-blue";
				break;
			case "2":
				bgClass = "card-blog-orange";
				tagClass = "orange";
				break;
			case "3":
				bgClass = "card-blog-purple";
				tagClass = "purple";
				break;
			case "5":
				bgClass = "card-blog-yellow";
				tagClass = "yellow";
				break;
			default:
				bgClass = "card-blog-dark-blue";
				tagClass = "dark-blue";
				break;
		}
	}
	bgClass = "card-blog-gray-light"; // Override for gray light background

	return (
		<div className={`sc-card-blog ${bgClass}`}>
			<div className="sc-card-blog__content">
				<div className="sc-card-blog__content__tag">
					{tags.length > 0 &&
						tags.map((tag, tagIndex) => (
							<Tag
								openLinkInNewTab={tag.openLinkInNewTab}
								as="a"
								key={tagIndex}
								href={
									tag.href?.includes("http")
										? tag.href
										: `${window.location.origin}/${tag.href}`
								}
								index={tagIndex}
							>
								{tag.text}
							</Tag>
						))}
				</div>
				<a href={link} className="sc-card-blog__content__title">
					<h5 className="sc-card-blog__content__title">{title}</h5>
				</a>
				<div className="sc-card-blog__content__date-container">
					{icon && (
						<img
							className="sc-card-blog__content__date-container__icon"
							src={
								icon?.includes("http")
									? icon
									: `${window.location.origin}${icon}`
							}
							alt="icono de fecha"
						/>
					)}
					<span className="sc-card-blog__content__date-container_date">
						{dayjs(creationDate).format("LL")}
					</span>
				</div>
				<span
					className="sc-card-blog__content__desc"
					dangerouslySetInnerHTML={{ __html: desc }}
				/>
			</div>
			{image ? (
				<div className="sc-card-blog__image-container">
					<img
						className="sc-card-blog__image-container__image"
						src={
							image?.includes("http")
								? image
								: `${window.location.origin}${image}`
						}
						alt={`Imagen de la entrada del blog ${title}`}
					/>
				</div>
			) : null}
		</div>
	);
};
